export const companyConfig = {
  NIU_EN_TAI: '纽恩泰',
}
